function _(a,n,e){var g=a(179);e.DataRange=g.DataRange;var R=a(178);e.DataRange1d=R.DataRange1d;var r=a(82);e.FactorRange=r.FactorRange;var t=a(83);e.Range=t.Range;var v=a(123);e.Range1d=v.Range1d}
//# sourceMappingURL=index.min.js.map